/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthenticationService {
    /**
     * User login
     * Authenticate a user and return a JWT token
     * @param requestBody
     * @returns any Login successful
     * @throws ApiError
     */
    public static cd5203E2D0A820E113F2F4Fdb2847(
        requestBody: {
            email: string;
            password: string;
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: {
            token?: string;
            token_type?: string;
            expires_in?: number;
            user?: Record<string, any>;
        };
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Account inactive`,
                422: `Validation error`,
            },
        });
    }
    /**
     * Get authenticated user
     * Get the currently authenticated user's information
     * @returns any User information retrieved successfully
     * @throws ApiError
     */
    public static e339E0E74860C0647Fd1D41Bbbbc13B2(): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth/me',
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
    /**
     * Refresh JWT token
     * Refresh the current JWT token
     * @returns any Token refreshed successfully
     * @throws ApiError
     */
    public static c7Bb98658Eb98880114621321Bd8D8(): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: {
            token?: string;
            token_type?: string;
            expires_in?: number;
        };
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/refresh',
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
    /**
     * Logout user
     * Invalidate the current JWT token
     * @returns any Successfully logged out
     * @throws ApiError
     */
    public static a05022A34Eef599E04Fb0A5254375B84(): CancelablePromise<{
        success?: boolean;
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/auth/logout',
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
}
